// 兰亭M头，顶部导航，侧边栏，搜索
import React from "react";
import { px2rem } from "utils/browser/resizer";
import Constant, { Host } from "utils/constant";

import Search from "./components/Search";
import { AssetImageUrl } from "assets/imgUrl";
import {
	getCategories,
	getCartstore,
	getCountries,
	getLanguages,
	getCurrencies,
	getUserProfile,
	GetCountriesResp,
	getUnPaidOrder,
	CountryInfo,
	GetUnPaidOrderResp,
	getInfo,
} from "headerServices/header/header";
import langGroup from "../../../assets/lang.json";
import getLangKeyValueFun from "../../../utils/lang";
import { LayoutProps, headerConstant } from "../WebHeader/webHeaderConstant";
import {
	CategoryLeft,
	GreyBg,
	LitbMHeader,
	GlobalStyle,
	HeaderLayout,
	HeaderSide,
	HeaderIcon,
	Title,
	CartIcon,
	Badge,
	Cover,
	Side,
	SideBody,
	HeaderTitle,
	CategoryList,
	CategoryChildren,
	CategorySideItem,
	NextIcon,
} from "./style";

const gettext = getLangKeyValueFun(langGroup);

interface HeaderState {
	userName: string;
	total_results: number;
	showSidebar: boolean;
	showSearchModal: boolean;
	showCountryModal: boolean;
	showCurrencyModal: boolean;
	countries: CountryInfo[];
	topCountries: CountryInfo[];
	currentCountry: CountryInfo;
	categories: any[];
	userCurrency: any;
	currencies: any[];
	showLanguageModal: boolean;
	userLanguage: any;
	languages: any[];
	hasUnPaidOrder: boolean;
	/** 低价APP 折扣应用国家国际化文案 */
	lowPriceCountryPriceOff: string;
	activeIndex: number; // 当前触发的类别
}

class Header extends React.Component<LayoutProps, HeaderState> {
	constructor(props) {
		super(props);
		this.state = {
			userName: "",
			total_results: 0,
			showSidebar: false,
			showSearchModal: false,
			showCountryModal: false,
			countries: [],
			topCountries: [],
			currentCountry: null,
			showCurrencyModal: false,
			userCurrency: {},
			currencies: [],
			showLanguageModal: false,
			userLanguage: {
				language_code: Constant.language || "en",
				language_name: "",
			},
			languages: [],
			categories: [],
			hasUnPaidOrder: false,
			lowPriceCountryPriceOff: "",
			activeIndex: -1,
		};
	}

	componentDidMount() {
		if (Constant.isLogin) {
			this.getUser();
		}
		this.getAppLowpriceCountry();
		this.getCart();
		this.getCate();
		this.getCountry();
		this.getLanguage();
		this.getCurrency();
		this.getUnPaidOrder();
	}
	// 获取用户信息
	getUser = () => {
		getUserProfile(
			{ sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined },
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { user = 0 } = res.info || {};
				const userName = user.email ? user.email.split("@")[0] : user.user_id;
				this.setState({ userName });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取未支付订单
	getUnPaidOrder = () => {
		getUnPaidOrder(
			{ sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined },
			{ onSentryCatch: this.props.onSentryCatch },
		).then((res: GetUnPaidOrderResp) => {
			if (res) {
				this.setState({ hasUnPaidOrder: !!res?.info?.total_results });
			}
		});
	};
	// 获取购物车数量
	getCart = () => {
		getCartstore(
			{
				sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined,
			},
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { total_results = 0 } = res.info || [];
				this.setState({ total_results });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取类目
	getCate = () => {
		getCategories(
			{ feature_category_header: "YES", categoryId: "1180" },
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const categories = res.info?.element_list || [];
				this.setState({ categories });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取country
	getCountry = () => {
		getCountries(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: GetCountriesResp) => {
				const { countries = [], topCountries = [] } = res.info || {};
				const currentCountry = countries.find(
					(item) => item.countryIsoCode3 === Constant.country,
				);
				this.setState({
					countries,
					topCountries,
					currentCountry,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取language
	getLanguage = () => {
		getLanguages(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { languages = [] } = res.info || [];
				const userLanguage = languages.find(
					(item) => item.language_code === Constant.language,
				) || {
					language_code: "en",
					language_name: "English",
				};
				this.setState({
					userLanguage,
					languages,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取currency
	getCurrency = () => {
		getCurrencies(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { currencies = [], new_currencies = [] } = res.info || {};
				let currencyList = [];
				if (new_currencies && new_currencies.length > 0) {
					currencyList = new_currencies;
				} else {
					currencyList = currencies;
				}
				const userCurrency =
					currencyList.find((item) => item.currency_code === Constant.currency) || {};
				this.setState({
					userCurrency,
					currencies: currencyList,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};

	// 底价APP规则应用国家列表
	getAppLowpriceCountry = () => {
		const ATTRNAME_KEY = "APP_LOWPRICE_COUNTRY";
		getInfo(
			{ namespace: "LITB.OTHER.COUNTRIES", attrName: ATTRNAME_KEY },
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { value = {} } = res.info || {};
				const keyValue: string = value[ATTRNAME_KEY] || "";
				if ((keyValue as string).split(",").includes(Constant.countryId)) {
					this.getAppLowPriceTextContent();
				}
			})
			.catch((err) => {
				console.warn(err);
			});
	};

	// 获取导流国际化文案
	getAppLowPriceTextContent = () => {
		const ATTRNAME_KEY = "app_show_banner_B_new";
		getInfo(
			{
				namespace: "LITB.APP.SERVER_B",
				attrName: ATTRNAME_KEY,
				nsLanguageCode: Constant.language,
			},
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { value = {} } = res.info || {};
				this.setState({ lowPriceCountryPriceOff: value[ATTRNAME_KEY] || "" });
			})
			.catch((err) => {
				console.warn(err);
			});
	};

	openSidebar = () => {
		document.body.classList.add("litb-m-fixscroll");
		this.setState({ showSidebar: true });
	};

	closeSidebar = () => {
		document.body.classList.remove("litb-m-fixscroll");
		this.setState({ showSidebar: false });
	};

	needLogin = (path: string) => {
		const BaseUrl = Host[String(Constant.isUat)];
		if (Constant.sessionKey && this.state.userName) {
			this.goPage(path);
			return;
		}
		window.location.href = `${BaseUrl.gmHost}/signin`;
	};

	stateChange = <T extends keyof HeaderState>(type: T, value: HeaderState[T]) => {
		this.setState({ [type]: value } as Pick<HeaderState, T>);
	};

	goPage = (path: string) => {
		window.location.href = path;
	};

	activeCategoryClick = (e, index) => {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();
		if (index === this.state.activeIndex)
			this.setState({
				activeIndex: -1,
			});
		else
			this.setState({
				activeIndex: index,
			});
	};
	render() {
		const { total_results, showSidebar, categories, userLanguage, showSearchModal } =
			this.state;

		const BaseUrl = Host[String(Constant.isUat)];
	
		const CategoryLeftItem = (item) => {
			const imgurl = item.left_image_url
				? item.left_image_url
				: item.category_image_url
				? item.category_image_url
				: "";
			return (
				<CategoryLeft>
					<GreyBg>
						{imgurl ? <img src={imgurl} alt={item.category_name} /> : null}
						<div />
					</GreyBg>
					<div>{item.category_name}</div>
				</CategoryLeft>
			);
		};
		return (
			<LitbMHeader>
				<GlobalStyle />
				<HeaderLayout>
					<HeaderSide>
						<HeaderIcon onClick={() => history.back()}>
							<img src={AssetImageUrl["ic_back@3x.png"]} alt="back" />
						</HeaderIcon>
						<HeaderIcon onClick={this.openSidebar}>
							<img src={AssetImageUrl["ic_menu@3x.png"]} alt="menu" />
						</HeaderIcon>
					</HeaderSide>
					<Title href="https://m.ador.com">
						<img
							src="https://m.ador.com/img/site/ado/wide-logo.png"
							style={{ width: px2rem(79) }}
							alt="ador"
						/>
					</Title>
					<HeaderSide>
						<HeaderIcon onClick={() => this.setState({ showSearchModal: true })}>
							<img
								src={AssetImageUrl["ic_search@3x.png"]}
								alt="search"
								style={{ width: px2rem(24), height: px2rem(24) }}
							/>
						</HeaderIcon>
						<CartIcon
							onClick={() =>
								this.goPage(`${BaseUrl.gmHost}/${userLanguage.language_code}/cart`)
							}>
							<img
								src={AssetImageUrl["tabbar_ic_cart@3x.png"]}
								alt="cart"
								style={{ width: px2rem(24), height: px2rem(24) }}
							/>
							{total_results || total_results === 0 ? (
								<Badge>
									<span>{total_results > 999 ? "999+" : total_results}</span>
								</Badge>
							) : null}
						</CartIcon>
					</HeaderSide>
				</HeaderLayout>
				{/* sidebar */}
				<Cover show={showSidebar} onClick={this.closeSidebar}></Cover>
				<Side show={showSidebar}>
					<SideBody style={{ overflow: "auto" }}>
						<div>
							<HeaderTitle>{gettext("All CateGories")}</HeaderTitle>
							{categories && categories.length > 0 ? (
								<CategoryList>
									{categories.map((item, index) => {
										return (
											<CategoryChildren key={"c_" + index}>
												<CategorySideItem
													key={index}
													style={{ backgroundColor: "#ffffff" }}
													onClick={() => this.goPage(`${BaseUrl.gmHost}/c/${item.category_url}_${item.category_id}?prm=1.2.c${item.category_id}.0`)}>
													{CategoryLeftItem(item)}
													{this.state.activeIndex === index ? (
														<NextIcon
															src={require("assets/images/unfold_header.png")}
															deg={0}
															alt={item.category_name}
															onClick={(e) => {
																this.activeCategoryClick(e, index);
															}}
														/>
													) : (
														<NextIcon
															src={require("assets/images/fold_header.png")}
															deg={0}
															alt={item.category_name}
															onClick={(e) => {
																this.activeCategoryClick(e, index);
															}}
														/>
													)}
												</CategorySideItem>
												{item.node_list &&
													this.state.activeIndex === index &&
													item.node_list.map((subitem, sindex) => (
														<CategorySideItem
															key={index + "_" + sindex}
															style={{ backgroundColor: "#f7f7f7" }}
															border
															onClick={() =>
																this.goPage(`${BaseUrl.gmHost}/c/${subitem.category_url}_${item.category_id}?prm=1.2.c${item.category_id}.0`)
															}>
															{CategoryLeftItem(subitem)}
															<NextIcon
																src={
																	AssetImageUrl["ic_next@3x.png"]
																}
																deg={0}
																alt={subitem.category_name}
															/>
														</CategorySideItem>
													))}
											</CategoryChildren>
										);
									})}
								</CategoryList>
							) : null}
						</div>
					</SideBody>
				</Side>
				{showSearchModal ? (
					<Search
						stateChange={this.stateChange}
						onSentryCatch={this.props.onSentryCatch}
					/>
				) : null}
			</LitbMHeader>
		);
	}
}

export default headerConstant(Header);
